import React, { useEffect, useRef } from "react";
import "./App.css";
import { ReactTagManager } from "react-gtm-ts";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

function App() {
  ReactTagManager.init(tagManagerArgs);
  const intercomInitialized = useRef(false);
  const BASE_URL = "https://wix.certifiedcode.io/ecwid-seenon";
  const [instance, setInstance] = React.useState({} as any);

  useEffect(() => {
    if (!intercomInitialized.current && instance.intercomToken && instance.storeProfile && instance.app) {
      const name = instance.storeProfile.account.accountName;
      const registrationDate = new Date(
        instance.storeProfile.account.registrationDate
      );
      const created_at = Math.floor(registrationDate.getTime() / 1000);
      const phone = instance.storeProfile.company.phone;
      const email = instance.storeProfile.account.accountEmail;
      const utm_source = instance.app.client_id;
      const options = {
        email,
        name,
        created_at,
        phone,
        user_hash: instance.intercomToken,
        utm_source,
      };
      window.Intercom("boot", options);
      intercomInitialized.current = true;
    }
  }, [instance]);

  useEffect(() => {
    try {
      // Initialize the application
      window.EcwidApp.init({
        app_id: "seen-on",
        autoloadedflag: true,
        autoheight: false,
      });

      // Initial instance fetch
      getInstance();

      // Function to update height
      const updateHeight = () => {
        var body = document.body,
          html = document.documentElement;

        var height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        );

        window.EcwidApp.setSize({ height: height });
      };

      // Initial height update
      updateHeight();

      // Set up intervals for both instance and height updates
      const instanceIntervalId = setInterval(getInstance, 10000);
      const heightIntervalId = setInterval(updateHeight, 1000);

      // Cleanup intervals on component unmount
      return () => {
        clearInterval(instanceIntervalId);
        clearInterval(heightIntervalId);
      };
    } catch (error) {
      console.error(error);
    }
  }, []);

  function getInstance() {
    fetch(
      BASE_URL + "/_functions/@certifiedcode/ecwid-repluggable-backend/auth",
      {
        headers: {
          Authorization: new URLSearchParams(window.location.search).get(
            "payload"
          )!,
        },
      }
    )
      .then((response) => response.json())
      .then((payload) => {
        setInstance(payload);
        window.EcwidApp.ready();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  return (
    <div className="settings-page cf">
      <div className="settings-page__header">
        <div className="settings-page__titles settings-page__titles--left">
          <h1 className="settings-page__title">
            SeenOn: Get Featured on News
          </h1>
          <div className="settings-page__subtitle">
            Catapult your brand with guaranteed publicity
          </div>
        </div>

        <div className="named-area">
          <div className="named-area__header">
            <div className="named-area__titles">
              <div className="named-area__title">Premium Media Features</div>
            </div>
            <div className="named-area__description">
              Elevate your brand's presence with guaranteed features on top-tier news sites. 
              Get featured on 200+ reputable platforms including Digital Journal, Newsmax, 
              Business Insider, and more. Your story will reach millions of engaged readers monthly.
            </div>
          </div>
          <div className="named-area__body">
            <div
              className="a-card a-card--normal"
              style={{ backgroundColor: "#2964de" }}
            >
              <div className="a-card__paddings">
                <div className="upgrade-element upgrade-element--inverted">
                  <div className="upgrade-element__core">
                    <div className="upgrade-element__data">
                      <div className="upgrade-element__title">
                        Start Building Your Media Presence Today
                      </div>
                      <div className="upgrade-element__content">
                        <div className="upgrade-element__text">
                          Get featured on premium news sites and establish your brand as an industry leader
                          with guaranteed media coverage across 200+ platforms.
                        </div>
                        <div className="upgrade-element__action">
                          {instance.store_id ? (
                            !instance?.subscription ? (
                              <button
                                type="button"
                                className="btn btn-medium btn-success upgrade-element__button"
                                onClick={() => {
                                  window.open(
                                    instance?.storeProfile
                                      ? encodeURI(
                                          "https://www.certifiedcode.us/upgrade/apps?checkout=" +
                                            JSON.stringify({
                                              settings: {
                                                allowLogout: false,
                                                allowDiscountRemoval: false,
                                              },
                                              items: [
                                                {
                                                  priceId:
                                                    "pri_01jk8qpjpx4kx40fmwedk222mf",
                                                  quantity: 1,
                                                },
                                              ],
                                              customer: {
                                                email:
                                                  instance.storeProfile.account
                                                    .accountEmail,
                                                business: {
                                                  name: instance.storeProfile
                                                    .account.accountName,
                                                },
                                                address: {
                                                  countryCode:
                                                    instance.storeProfile
                                                      .company.countryCode,
                                                  postalCode:
                                                    instance.storeProfile
                                                      .company.postalCode,
                                                  city: instance.storeProfile
                                                    .company.city,
                                                },
                                              },
                                              customData: {
                                                store_id: `${instance.store_id}`,
                                              },
                                            })
                                        )
                                      : undefined,
                                    "_blank"
                                  );
                                }}
                              >
                                <span className="svg-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="488px"
                                    height="466px"
                                    viewBox="0 0 488 466"
                                    version="1.1"
                                    focusable="false"
                                  >
                                    <path d="M382.437 465.1 C379.306 465.1 376.2 464.3 373.3 462.8 L244 394.8 L114.72 462.8 C108.084 466.3 100 465.7 94 461.3 C87.919 456.9 84.9 449.4 86.1 442 L110.84 298 L6.254 196.1 C0.897 190.9 -1.1 183 1.3 175.9 C3.595 168.8 9.7 163.6 17.2 162.5 L161.686 141.5 L226.336 10.6 C232.953 -2.9 255 -2.9 261.6 10.6 L326.295 141.5 L470.817 162.5 C478.241 163.6 484.4 168.8 486.7 175.9 C489.032 183.1 487.1 190.9 481.7 196.1 L377.14 298.1 L401.185 438.3 C402.051 440.4 402.5 442.8 402.5 445.4 C402.505 456.3 393.7 465.1 382.8 465.1 C382.754 465.1 382.6 465.1 382.4 465.1 L382.437 465.1 Z"></path>
                                  </svg>
                                </span>
                                <span>Start Your Media Journey</span>
                              </button>
                            ) : (
                              <button
                                className="btn btn-medium btn-success upgrade-element__button"
                                onClick={() => {
                                  window.Intercom("showSpace", "tickets");
                                }}
                              >
                                Track Campaign
                              </button>
                            )
                          ) : (
                            <div className="loader"></div>
                          )}
                        </div>
                      </div>
                      <div className="upgrade-element__note">
                        <div>Get one publication for $59, renews automatically every month. Cancel anytime.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="named-area">
          <div className="named-area__header">
            <div className="named-area__titles">
              <div className="named-area__title">
                Why Choose SeenOn?
              </div>
            </div>
            <div className="named-area__description">
              Discover how our comprehensive media solution can transform your brand's visibility
            </div>
          </div>
          <div className="named-area__body">
            <div className="a-card a-card--normal">
              <div className="a-card__paddings">
                <div>
                  <div className="promo-row">
                    <div className="promo-row__content">
                      <ul className="titled-items-list">
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Premium Exposure
                          </div>
                          <div className="titled-item__content">
                            Get featured on top-tier news sites and reach millions of engaged readers every month.
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Credibility Boost
                          </div>
                          <div className="titled-item__content">
                            Build trust with your audience through association with well-respected media outlets.
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Wide Reach
                          </div>
                          <div className="titled-item__content">
                            Guarantee publicity on 200+ news sites including Google News, Fox News, and Business Insider.
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Effortless Publishing
                          </div>
                          <div className="titled-item__content">
                            Streamline your media presence with easy publication on renowned platforms.
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="named-area__footer">
            <div className="named-area__footer-description"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
